import React from 'react';
import { Link } from 'react-router-dom';
import { ADD_BETSLIP } from '../../../routes/paths';

const NoBetsAuthenticated = () => (
  <div className="no-bets">
    <section className="no-bets__section">
      <h2 className="no-bets__heading">No recent activity</h2>
    </section>
    <section className="no-bets__section">
      <p className="no-bets__paragraph">
        When placing a bet using any of our in-store betting points, tap your Plus card
        and your bets will be added here.
      </p>
    </section>
    <section className="no-bets__section">
      <p className="no-bets__paragraph">
        <span className="no-bets__divider no-bets__divider--inline" />
        <b>OR</b>
        <span className="no-bets__divider no-bets__divider--inline" />
      </p>
    </section>
    <section className="no-bets__section">
      <p className="no-bets__paragraph">
        <Link to={ADD_BETSLIP} className="no-bets__link">
          Add your bets manually
        </Link>
      </p>
    </section>

  </div>
);

export default NoBetsAuthenticated;
